import { useCallback, useContext } from 'react';
import { addAnswer, removeAnswers } from 'store/actions';
import { AppContext } from 'providers/AppProvider';
import { buildAnswer, getDropdownValue } from 'helpers';
import { Choice, QuestionLabel } from './Labels';
import { Dropdown } from 'components';
import { QuestionProps } from 'types';

export function QuestionDropdown(props: QuestionProps) {
	const { caption, choices, id, language1Caption, testId } = props;
	const { dispatch, state } = useContext(AppContext);
	const { language, riskq } = state;
	const answer = riskq.find(a => id === a.questionId && testId === a.testId);
	const label = QuestionLabel(language.language, caption, language1Caption);

	const onSelect = useCallback(
		(index: number) => {
			const choiceId = choices[index].id;
			const payload = { riskq: [buildAnswer(testId, id, choiceId)] };
			dispatch([removeAnswers, payload]);
			dispatch([addAnswer, payload]);
		},
		[choices, id, testId, dispatch]
	);

	return (
		<div className="col">
			<input name={id.toString()} type="hidden" value={getDropdownValue(choices, answer)} />
			<Dropdown items={choices.map(Choice)} label={label} onSelect={onSelect} />
		</div>
	);
}
